import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
  useRef
} from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import {
  Drawer,
  Button,
  Steps,
  Form,
  Input,
  Radio,
  notification,
  Space,
  Select,
  Alert,
  Upload,
  Tag,
  Typography,
  Divider,
  Tooltip,
  Menu,
  Dropdown,
  Row,
  Col,
  Modal,
  Popconfirm,
  Table,
  Empty,
  Badge
} from "antd";
import {

  EllipsisOutlined,

} from "@ant-design/icons";
import { useSelector } from 'react-redux';
import { CopyOutlined, MoreOutlined } from "@ant-design/icons";
import documentManagementAPI from '../../../../restAPI/DocumentManagement';
import AccountPayableAPI from "../../../../restAPI/AccountPayableAPI"
import ShareDocument from '../../../Reports/DocumentSummary/ShareDocument';
import StatusTrial from './StatusTrial';
import dayjs from "dayjs";

const { Title, Text, Paragraph } = Typography;
const Context = React.createContext({
  name: "Default",
});
const { Step } = Steps;
const { TextArea } = Input;
const onSearch = (value) => {
  console.log("search:", value);
};
const StepForm = forwardRef((props, ref) => {
  const { record } = props;
  const navigate = useNavigate();
  const [selectedRecord, setSelectedRecord] = useState({});
  const [isCancelBtnDisable, setIsCancelBtnDisable] = useState(false);
  const [cancelRecord, setCancelRecord] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const [viewData, setViewData] = useState({});
  const { token } = useSelector(state => state.auth);
  const { Dragger } = Upload;
  const [attachments, setAttachments] = useState([]);
  const [toEmails, setToEmails] = useState(['buyer@gmail.com']);
  const [isStatusTrialOpen, setIsStatusTrialOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const statusTrialRef = useRef(null);
  const [payload, setPayload] = useState({});
  const [isPopconfirmVisible, setIsPopconfirmVisible] = useState(false);
  const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRemark, setCancelRemark] = useState("");
  const [cancelConfirmedRecords, setCancelConfirmedRecords] = useState({});
  const [allDocumentTypes, setAllDocumentTypes] = useState([]);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const shareDocumentRef = useRef(null);

  const handleCopyUrl = async (url) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
      } else {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      notification.success({
        message: 'URL Copied',
        description: 'The URL has been successfully copied to your clipboard.',
        placement: 'bottomLeft',
      });
    } catch (err) {
      notification.error({
        message: 'Failed to copy',
        description: 'Failed to copy URL to clipboard.',
        placement: 'bottomLeft',
      });
      console.error('Failed to copy:', err);
    }
  };

  const statusTrailDrawer = (record) => {
    setIsStatusTrialOpen(true);
    if (statusTrialRef.current) {

      statusTrialRef.current.openDrawer(record);
    }
  };

  const closeStatusTrailDrawer = () => {
    setIsStatusTrialOpen(false);
  };

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: (record) => {
      GetAllDocumentTypes();
      getViewData(token, record);
      setSelectedRecord(record);
      let cancelRecord = [];
      cancelRecord.push(record);
      let selectedListforCancel = cancelRecord.map(item => {
        setIsCancelBtnDisable(item.status == "deleted" ? true : dayjs().diff(dayjs(item.uploadDate), 'hour') <= 72 ? false : true)
        return {
          ...item,
          cancellationStatus: item.status == "deleted" ? "Cancellation Completed" : dayjs().diff(dayjs(item.uploadDate), 'hour') <= 72 ? "Ready for Cancellation" : "Cancellation Expired"
        }
      });
      setCancelRecord(selectedListforCancel)
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      viewData({});
      setSelectedRecord({});
      setCancelRecord([])
      setVisible(false); // Close drawer
    },
  }));

  useEffect(() => {
    if (!visible) {
      setViewData({});
      setSelectedRecord({});
      setAttachments([]);
      setToEmails(['buyer@gmail.com']);
      setCurrentStep(0);
    }
  }, [visible]);

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };


  const handleUpload = ({ file }) => {
    setAttachments((prev) => [...prev, file]);
  };

  const GetAllDocumentTypes = async () => {
    await AccountPayableAPI.GetDocumentTypes(token, localStorage.getItem('groupId'), /*companyId*/ localStorage.getItem('companyId'))
      .then((res) => {
        if (res?.data) {
          const documetTypes = res.data.map((rowValue) => ({
            value: rowValue.code,
            label: rowValue.description,
            code: rowValue.code
          })).sort((a, b) => a.label.localeCompare(b.label));
          setAllDocumentTypes(documetTypes);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Document Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Document Type found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const getViewData = async (token, record) => {
    const formData = new FormData();

    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id != undefined ? record?.tPS_Id : "");

    await documentManagementAPI.GetViewData(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId"),
      formData
    )
      .then((response) => {
        const modifiedDate = formatDate(response.data.GeneralInformation?.InvoiceDateTime);
        if (response.data.GeneralInformation) {
          response.data.GeneralInformation.InvoiceDateTime = modifiedDate;
        }
        const netAmount = parseFloat(response.data?.GeneralInformation?.InvoiceTotalNetAmount).toLocaleString('en-US', { minimumFractionDigits: 2 }) + " " + response.data?.GeneralInformation?.Currency;
        if (response.data.GeneralInformation) {
          response.data.GeneralInformation.InvoiceTotalNetAmount = netAmount;
        }
        setViewData(response.data);
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  const removeAttachment = (fileName) => {
    setAttachments(attachments.filter((file) => file.name !== fileName));
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const formatDate = (datetring) => {
    const date = new Date(datetring);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const formatAddress = (address) => {
    if (!address) return '';

    const parts = [];

    if (address.addressLine1) parts.push(address.addressLine1);
    if (address.addressLine2) parts.push(address.addressLine2);
    if (address.addressLine3) parts.push(address.addressLine3);

    const cityStatePostal = [];
    if (address.city) cityStatePostal.push(address.city);

    if (address.state) {
      const state = address.state.code || address.state.name;
      if (state) cityStatePostal.push(state);
    }

    if (address.postalZone) cityStatePostal.push(address.postalZone);

    if (cityStatePostal.length > 0) {
      parts.push(cityStatePostal.join(' '));
    }

    return parts.join(', ');
  };


  const [api, contextHolder] = notification.useNotification();
  const { Option } = Select;

  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  //cancellation invoice

  const onChangeReason = (value) => {
    setCancelReason(value);
  };

  const onChangeRemark = (e) => {
    console.log("on change remark", e.target.value)
    setCancelRemark(e.target.value);
  };

  const showSingleCancelModal = (record) => {
    let cancelRecords = [];
    cancelRecords.push(record);
    setSelectedRecord(cancelRecords);
    setIsModalVisible(true);
  };

  const handleCancelPopConfirm = () => {
    setCancelButtonDisabled(true);
    openNotificationWithIcon(
      "error",
      "Abort",
      `Invoice Cancellation aborted`,
      "bottomLeft"
    );

    setTimeout(() => {
      setCancelButtonDisabled(false);
    }, 3000);

  }

  const handleCancelInvoiceClick = () => {
    const cancellingRecords = []
    cancellingRecords.push("testinvoNum")
    selectedRecord.filter((rec) => {
      if (rec.cancellationStatus === "Ready For Cancellation") {
        cancellingRecords.push(" " + rec.invoiceNumber);
      }
    }
    );

    setCancelConfirmedRecords({
      cancelling: [cancellingRecords],
    })

    setIsPopconfirmVisible(true);
  };

  const handleCancelConfirm = async () => {
    setIsPopconfirmVisible(false);

    const payload = []
    selectedRecord.map((row) => {
      payload.push({
        groupId: localStorage.getItem("groupId"),
        companyId: localStorage.getItem("companyId"),
        TPS_Id: row.tPS_Id,
        MOGU_UUID: row.documentMoguID,
        TPS_Ref_Num: row.TPS_Ref_Num,
        reason: cancelReason,
        remark: cancelRemark
      })
    })

    const handleCancelInvoiceClick = () => {
      const cancellingRecords = []
      cancellingRecords.push("testinvoNum")
      selectedRecord.filter((rec) => {
        if (rec.cancellationStatus === "Ready For Cancellation") {
          cancellingRecords.push(" " + rec.invoiceNumber);
        }
      }
      );

      setCancelConfirmedRecords({
        cancelling: [cancellingRecords],
      })

      setIsPopconfirmVisible(true);
    };

    documentManagementAPI.cancelDocument(token, payload)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Cancel Document",
          `${response.message}`,
          "bottomLeft"
        );
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Cancel Document Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Cancel Document Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
    setIsModalVisible(false);

  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const cancellationColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Cancellation Status",
      dataIndex: "cancellationStatus",
      key: "cancellationStatus",
      render: (status) => (
        <Badge
          color={
            status == "Cancellation Completed"
              ? "green"
              : status == "Ready for Cancellation"
                ? "cyan"
                : "volcano"
          }
          text={status}
        />
      ),
    },
  ];

  const upload = () => {
    navigate('../AccountReceivable/Upload');
  };

  const handleDownloadPDF = (record) => {

    const formData = new FormData();

    formData.append("groupId", localStorage.getItem("groupId"));
    formData.append("companyId", localStorage.getItem("companyId"));
    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id);

    documentManagementAPI.downloadPDF(token, formData)
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  const shareDocumentDrawer = (record) => {
    setIsShareOpen(true);
    if (shareDocumentRef.current) {

      shareDocumentRef.current.openDrawer(record);
    }
  };

  const closeSshareDocumentDrawer = () => {
    setIsShareOpen(false);
  };

  const menuItems = (selectedRecord) => {

    return [
      (selectedRecord?.base64PDF) ? { key: "downloadPdf", label: "Download PDF", onClick: () => handleDownloadPDF(record) } : null,
      { key: "share", label: "Share", onClick: () => shareDocumentDrawer(selectedRecord) },
      { key: "status Trail", label: "Status Trail", onClick: () => statusTrailDrawer(record), },
      { key: "creditNote", label: "Credit Note", onClick: () => upload(), },
      { key: "debitNote", label: "Debit Note", onClick: () => upload(), },
      { key: "rn", label: "Refund Note", onClick: () => upload(), },
      { key: "cancel", label: "Cancel", onClick: () => showSingleCancelModal(record) },
    ].filter(Boolean);
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer

        title={
          <div justify="space-between" align="left">

            <span style={{ position: 'relative', top: '5px' }}>View Document Summary</span>
            <Dropdown
              overlay={
                <Menu>
                  {menuItems(selectedRecord).map((item) => (
                    <Menu.Item
                      key={item.key}
                      onClick={item.onClick}
                    >
                      {item.link ? (
                        <Link to={item.link}>{item.label}</Link>
                      ) : (
                        item.label
                      )}
                    </Menu.Item>
                  ))}
                </Menu>
              }
              trigger={["click"]}
            >
              <Button style={{ float: 'right' }}>
                Options
                <MoreOutlined style={{ marginLeft: 8 }} />
              </Button>
            </Dropdown>
          </div>
        }
        width={700}
        visible={visible}
        onClose={() => setVisible(false)}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={() => setVisible(false)}>
              Exit
            </Button>


          </div>
        }
      >
        {viewData &&
          <div style={{ marginTop: 4 }}>

            {/* Section 1 */}
            <Divider style={{ borderColor: '#7cb305' }}>General Information</Divider>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <Text strong>Invoice Number:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceNumber}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Cancellation Countdown:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.CancellationCountdown}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Document Type:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{allDocumentTypes.find(d => d.code === viewData?.GeneralInformation?.DocumentType)?.label}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Classification Code:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.Classification}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Invoice Date & Time:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceDateTime}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Currency:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.Currency}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Invoice Total Net Amount:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceTotalNetAmount}</Paragraph>
              </Col>
            </Row>

            <Divider style={{ borderColor: '#7cb305' }}>Supplier Details</Divider>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <Text strong>Name:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.SupplierDetails?.Name}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>TIN:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.SupplierDetails?.Tin}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Address:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>
                  {formatAddress(viewData?.SupplierDetails?.Address)}
                </Paragraph>
              </Col>
            </Row>

            <Divider style={{ borderColor: '#7cb305' }}>Buyer Details</Divider>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <Text strong>Name:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.BuyerDetails?.Name}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>TIN:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>{viewData?.BuyerDetails?.Tin}</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>Address:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>
                  {formatAddress(viewData?.BuyerDetails?.Address)}
                </Paragraph>
              </Col>
            </Row>

            <Divider style={{ borderColor: '#7cb305' }}>LHDN</Divider>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <Text strong>Status:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>Success</Paragraph>
              </Col>

              <Col span={10}>
                <Text strong>LHDN Response:</Text>
              </Col>
              <Col span={14}>
                <Paragraph style={{ marginBottom: '8px' }}>
                  Description: Successful transaction or request completed successfully.
                </Paragraph>
              </Col>
            </Row>

            <Divider />
            {/* Section 5 */}
            <Space direction="vertical" size="small" style={{ width: '100%' }}>

              <Text strong>URL:</Text>
              <Input
                value={viewData?.LHDNInformation?.URL}
                readOnly
                addonAfter={
                  <Tooltip title="Copy URL">
                    <CopyOutlined onClick={() => handleCopyUrl(viewData?.LHDNInformation?.URL)} style={{ cursor: 'pointer' }} />
                  </Tooltip>
                }
                style={{
                  borderColor: '#d9d9d9',
                  borderRadius: '4px',
                  marginBottom: '8px',
                }}
                onClick={(e) => e.target.select()}
              />
            </Space>
          </div>
        }
      </Drawer>
      {/*Cancel modal */}
      <Modal
        title="Are you sure you want to cancel this document?"
        visible={isModalVisible}
        width={700}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" size="large" onClick={handleCancel}>
            Close
          </Button>,
          <Popconfirm
            title={`Out of ${selectedRecord.length} selected invoices, ${cancelConfirmedRecords?.cancelling?.length} invoices will be sent for cancellation. Do you want to proceed ?`}
            open={isPopconfirmVisible}
            onConfirm={() => handleCancelConfirm()}
            onCancel={handleCancelPopConfirm}
            onOpenChange={setIsPopconfirmVisible}
            okText="Yes"
            cancelText="No"
            cancelButtonProps={{ disabled: cancelButtonDisabled }}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            <Button key="submit" size="large" type="primary" onClick={handleCancelInvoiceClick} disabled={!cancelReason.length > 0}>
              Yes, Cancel!
            </Button>
          </Popconfirm>
          ,
        ]}
      >

        <h4>Selected Documents</h4>
        <div
          style={{
            maxWidth: '100%', // Ensure the container doesn't exceed its width
            overflowX: 'auto', // Enable horizontal scroll
          }}
        >
          <Table
            dataSource={cancelRecord}
            columns={cancellationColumns}
            pagination={{ pageSize: 5 }}
            size="small"
            locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!' /> }}
          />
        </div>
        <br />
        <Form layout="vertical">
          <Form.Item
            label="Select a Reason"
            name="reason"
            required
            rules={[
              { required: true, message: "Reason is required." },
            ]}
          >
            <Select
              size="large"
              style={{ width: 350 }}
              onChange={onChangeReason}
              placeholder="Select a Reason"
            >
              <Option value="Customer Request">Customer Request</Option>
              <Option value="System Issue">System Issue</Option>
              <Option value="Other">Other</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Remark"
            name="remark"
          >
            <Input.TextArea rows={4}
              onChange={onChangeRemark}
              placeholder="Enter your remark" />
          </Form.Item>
        </Form>
      </Modal>
      {isStatusTrialOpen && (<StatusTrial ref={statusTrialRef} open={isStatusTrialOpen} record={selectedRecord} onClose={closeStatusTrailDrawer} />)}
      <ShareDocument ref={shareDocumentRef} open={isShareOpen} onClose={closeSshareDocumentDrawer} record={selectedRecord} />
    </Context.Provider>
  );
});

export default StepForm;
